const defaultZIndex = 10500

export default (offset = 0) => defaultZIndex + offset